import { List } from "immutable";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { CareerCenterJobCategories } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";
import { CareerCenterHelper } from "../../../models/careerCenter/CareerCenterHelper";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    jobs: state.careerCenter.jobs,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
});

type OwnProps = RouteComponentProps<{
}> & {
};

interface ConnectedState {
    api: Api;
    jobs: List<M.CareerCenter.JobPost>;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
}

interface OwnState {
    featuredJobs: M.CareerCenter.JobPost[];
    loadingFeatured: boolean;
    searchText: string;
}

class LandingComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    private _isMounted = false;

    public constructor(props: any) {
        super(props);
        this.state = {
            featuredJobs: [],
            loadingFeatured: true,
            searchText: "",
        };
    }

    public componentDidMount() {
        this._isMounted = true;

        // populate featured jobs from state if any available
        if (this.props.jobs.size) {
            const featuredJobs = _.orderBy(this.props.jobs.toArray(), ["featured", "postedOn"], ["desc", "desc"]).slice(0, 3);
            if (featuredJobs.length) {

                this.setState({ ...this.state, featuredJobs, loadingFeatured: false });
            }
        }

        this.loadFeaturedJobs();
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const browseLinks = _.sortBy(CareerCenterJobCategories.Values, "sort").map((c, i) => (
            <li key={i}><Link to={`${Paths.CareerCenter.JobDirectory}?cat=${c.id}`}>{c.name}</Link></li>
        ));
        browseLinks.push(<li key={CareerCenterJobCategories.Values.length}><Link to={`${Paths.CareerCenter.JobDirectory}?browse=location`}>Location</Link></li>);

        let featuredJobs = this.state.featuredJobs.length
            ? <Comp.Generic.WrapperLess>
                <h2 style={{ textAlign: "center" }}>Latest Job Postings</h2>
                <ul className="career-features">
                    {this.state.featuredJobs.map((j, i) => (
                        <li key={i}>
                            <FeaturedJob job={j} />
                        </li>
                    ))}
                </ul>
                {/* <p style={{ textAlign: "center" }}><Link to={Paths.CareerCenter.Landing}>Employers, feature your listing &raquo;</Link></p> */}
            </Comp.Generic.WrapperLess>
            : null;

        if (!featuredJobs && this.state.loadingFeatured)
            featuredJobs = <Comp.Generic.WrapperLess>
                <h2 style={{ textAlign: "center" }}>Latest Job Postings</h2>
                <ul className="career-features">
                    <li style={{ position: "relative", minHeight: "200px" }}><Comp.Generic.LoadingSpinner show /></li>
                    <li style={{ position: "relative", minHeight: "200px" }}><Comp.Generic.LoadingSpinner show /></li>
                    <li style={{ position: "relative", minHeight: "200px" }}><Comp.Generic.LoadingSpinner show /></li>
                </ul>
                {/* <p style={{ textAlign: "center" }}><Link to={Paths.CareerCenter.Landing}>Employers, feature your listing &raquo;</Link></p> */}
            </Comp.Generic.WrapperLess>;

        return <Comp.Page.PublicPage additionalClasses="full" pageTitle="Retina Career Center">
            <div id="content-primary">

                <div className="career-intro" id="home-intro">
                    <div className="highlight" id="home-intro-primary">
                        <h2>Job seekers</h2>

                        <h3>Search</h3>

                        <form onSubmit={(e) => this.onSearchSubmit(e)}>
                            <div className="search">
                                <input
                                    className="search-txt"
                                    title="Search"
                                    placeholder="Job title or keyword&hellip;"
                                    value={this.state.searchText || ""}
                                    onChange={(e) => this.setState({ ...this.state, searchText: e.target.value })}
                                />
                                <button aria-label="Go" className="search-button" type="button" onClick={() => this.onSearchSubmit()}>
                                    <i aria-hidden="true" className="fa fa-search"></i>
                                </button>
                            </div>
                        </form>

                        <h3>Browse jobs by</h3>

                        <div className="browse">
                            <ul>
                                {browseLinks}
                            </ul>
                        </div>
                    </div>
                    <div className="highlight" id="home-intro-secondary">
                        <h2>Employers</h2>

                        <h3>Post a job opening</h3>
                        <p><Link className="action" to={Paths.CareerCenter.Job.Post}>Post a job</Link></p>

                        <h3>Find qualified candidates</h3>
                        <p><Link className="action" to={Paths.CareerCenter.ResumeDirectory}>Search resumes</Link></p>
                    </div>
                </div>

                <h2 style={{ textAlign: "center" }}>Job seeker tools</h2>

                <ul className="career-tools">
                    <li>
                        <JobSeekerTool icon="file-o" label="Upload your resume" url={Paths.CareerCenter.Resume.Post}>
                            Let employers find you
                        </JobSeekerTool>
                    </li>
                    <li>
                        <JobSeekerTool icon="envelope-o" label="Get job alerts via email" url={Paths.User.CareerCenter.Resumes}>
                            Postings sent to your inbox
                        </JobSeekerTool>
                    </li>
                    <li>
                        <JobSeekerTool icon="lightbulb-o" label="Kick start your job search" url={Paths.CareerCenter.AdviceResources}>
                            Resources to help you succeed
                        </JobSeekerTool>
                    </li>
                </ul>

                <hr />

                {featuredJobs}

            </div>
            <div id="content-secondary"></div>
            <div className="clear"></div>
        </Comp.Page.PublicPage>;
    }

    private async loadFeaturedJobs() {
        const qp = { queryParams: { count: 3, featured: false }}; // TODO: Change to featured: true once flag is implemented
        const result = await this.props.api.get<M.CareerCenter.JobPost[]>(Api.endpoints.careerCenter.jobs, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            this.setState({ featuredJobs: result.data, loadingFeatured: false });
        }
    }

    private onSearchSubmit(e?: React.FormEvent<HTMLFormElement>) {
        if (this.state.searchText && this.state.searchText.length >= 2)
            this.props.goto(Paths.CareerCenter.JobDirectory + "?q=" + encodeURIComponent(this.state.searchText));
        else
            this.props.goto(Paths.CareerCenter.JobDirectory);

        if (e)
            e.preventDefault();
        return false;
    }
}

export const Landing: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(LandingComponent) as any);

interface JobSeekerToolProps {
    icon: string;
    label: string | JSX.Element;
    url: string;
}

const JobSeekerTool: React.SFC<JobSeekerToolProps> = (props) => {
    return <Link to={props.url}>
        <span className="fa-stack fa-lg">
            <Comp.Generic.Icon icon="circle fa-stack-2x" />
            <Comp.Generic.Icon icon={props.icon + " fa-stack-1x fa-inverse"} />
        </span>
        <span className="career-tools-label">
            <strong>{props.label}</strong>
            {props.children}
        </span>
    </Link>;
};

interface FeaturedJobProps {
    job: M.CareerCenter.JobPost;
}

const FeaturedJob: React.SFC<FeaturedJobProps> = (props) => {
    const job = props.job;
    const locDisplay = M.Generic.AddressHelper.displayCityStateInline(job.location, "name", false);

    let orgLoc = null;
    if (job.organization && locDisplay)
        orgLoc = <Comp.Generic.WrapperLess>{job.organization}<br />{locDisplay}</Comp.Generic.WrapperLess>;
    else if (job.organization)
        orgLoc = job.organization;
    else if (locDisplay)
        orgLoc = locDisplay;

    return <Link to={CareerCenterHelper.jobDetailsLink(job)}>
        <strong>{job.title}</strong>
        {orgLoc}
        <span className="mute">
            Posted {moment(Utility.fromApiDate(job.postedOn)).format("MMMM D, YYYY")}
        </span>
    </Link>;
};



// WEBPACK FOOTER //
// ./src/containers/careerCenter/landing/Landing.tsx